import { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { SiteContentContext } from '../context/SiteContentContext';
import QuestionModal from '../components/QuestionModal';
import { useSeo } from '../hooks/useSeo';
import '../styles/fleet_page.css';

const TeamPage = ({ isPreview = false }) => {
  useSeo({
    title: 'Команда и инструкторы',
    description: 'Инструкторы и капитаны парусной школы The Sailing Doctor — опытные яхтсмены с международными сертификатами.',
  });
  const { content } = useContext(SiteContentContext);
  const [isQuestionOpen, setIsQuestionOpen] = useState(false);
  const instructors = content.instructors || [];
  const p = isPreview ? '/preview' : '';

  return (
    <main>
      <section className={`fleet-page-hero${content.teamHeroImage ? " has-cover" : ""}`} style={content.teamHeroImage ? { backgroundImage: `url(${content.teamHeroImage})` } : {}}>
        <h1>Наша команда</h1>
        <p>Опытные инструкторы и капитаны парусной школы</p>
      </section>
      <div className="fleet-page">

      {instructors.length === 0 ? (
        <div className="fleet-page-empty">
          <p>Инструкторы ещё не добавлены. Зайдите в <Link to="/admin">админку</Link> и добавьте их во вкладке 👨‍✈️ Инструкторы.</p>
        </div>
      ) : (
        <div className="team-grid">
          {instructors.map(inst => (
            <Link key={inst.id} to={`${p}/instructor/${inst.slug || inst.id}`} className="team-card">
              <div className="team-card-photo">
                {inst.photo
                  ? <img src={inst.photo} alt={inst.name} className="team-card-img" />
                  : <span className="team-card-no-photo">🧑‍✈️</span>
                }
              </div>
              <div className="team-card-body">
                <h2>{inst.name}</h2>
                {inst.title && <p className="team-card-title">{inst.title}</p>}
                {inst.bio && <p className="team-card-bio">{inst.bio}</p>}
                <span className="fleet-card-more">Подробнее →</span>
              </div>
            </Link>
          ))}
        </div>
      )}
      </div>
      <section className="cta-section">
        <h2>Остались вопросы?</h2>
        <p>Напишите нам — ответим в течение дня.</p>
        <button className="cta-button" onClick={() => setIsQuestionOpen(true)}>Задать вопрос</button>
      </section>
      <QuestionModal isOpen={isQuestionOpen} onClose={() => setIsQuestionOpen(false)} pageTitle="Команда" />
    </main>
  );
};

export default TeamPage;
